/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { IDs } from '../models/IDs';

export class GroupToRoleMapping {
  /**
  * The group name of the mapping
  */
  'groupName': string;
  /**
  * The role to projects mappings of the viewer
  */
  'roleToProjectsMappings': { [key: string]: IDs; };

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "groupName",
      "baseName": "groupName",
      "type": "string",
      "format": ""
    },
    {
      "name": "roleToProjectsMappings",
      "baseName": "roleToProjectsMappings",
      "type": "{ [key: string]: IDs; }",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return GroupToRoleMapping.attributeTypeMap;
  }

  public constructor() {
  }
}

